<template>
  <div>
    <logged-in-header />
    <product-creation />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import productCreation from "../components/product-creation/ProductCreation";

export default {
  components: {
    loggedInHeader,
    productCreation
  }
};
</script>
